import { localScopeSlug } from "../platform/tenantIdentity";
import { personalScope } from "../utils/personalStorage";
import { useCompatMember, useCompatOrganization } from "./stytch-compat";

/**
 * The person and project on screen (`personalScope`), under which the person's own work in
 * progress is kept; null until both are known. The compat hooks read the tenant scope context, so
 * an admission re-renders it.
 */
export function usePersonalScope(): string | null {
    const { organization } = useCompatOrganization();
    const { member } = useCompatMember();
    return personalScope(localScopeSlug(organization?.organization_slug), member?.member_id);
}
